export default __webpack_public_path__ + "c14bac79d52b1121a98ac6d439249915.png";